import $ from 'jquery';
import select2 from 'select2';
import Pikaday from 'pikaday';
import moment from 'moment';

$(function() {
    const $form  = $('.reward-form');
    if ($form.length) {
        // Insurance claims show certain fields
        const $isInsurance = $form.find('input[type=radio][name=isInsurance]');
        const $insuranceFields = $form.find('[data-insurance-info]');
        $isInsurance.change(function() {
            insuranceReveal(this.value);
        });

        insuranceReveal($isInsurance.filter(':checked').val());

        function insuranceReveal(value) {
            if (value == '0') {
                $insuranceFields.slideUp();
            } else if (value == '1') {
                $insuranceFields.slideDown();
            }
        }

        // Set up service provider select box
        const $serviceProviderSelect = $form.find('#service-provider');
        $serviceProviderSelect.select2({
            ajax: {
                url: '/service-providers.json',
                dataType: 'json',
                delay: 250,
                data: function(params) {
                    return {
                        search: params.term,
                        page: params.page
                    };
                },
            },
            placeholder: 'Select a Service Provider',
            escapeMarkup: function (markup) { return markup; }, // let our custom formatter work
            templateResult: formatServiceProvider,
            templateSelection: formatSelection,
            minimumInputLength: 3,
        });

        // Set up datepicker
        const $invoiceDate = $form.find('#invoice-date');
        let invoiceDatePicker = new Pikaday({
            field: $invoiceDate[0],
            firstDay: 1,
            format: 'YYYY-MM-DD',
        });

        // Set up donation amount representation
        const $invoiceTotal = $form.find('#invoice-total');
        const $donationAmount = $form.find('.reward-form-donation-amount');
        $invoiceTotal.keyup(function( event ) {
            let value = $(event.target).val();
            if (value > 0) {
                const selection = document.querySelector(".select2-search-result-selection");
                let rate = .03;
                if (selection) {
                    rate = selection.getAttribute('data-donation-rate') || .03;
                }
                let donation = value * rate;
                $donationAmount.text('$' + donation.toFixed(2));
            } else {
                $donationAmount.text('$xx.xx');
            }
        });
        $invoiceTotal.keyup();
    }

    // Formating functions for the select2 results
    function formatSelection(selection) {
        if (!selection.name) {
            return 'Please choose a Service Provider';
        }
        return '<div data-donation-rate="' + selection.rate + '" class="select2-search-result-selection">' + selection.name + ' - ' + selection.city + ', ' + selection.region + '</div>';
    }
    function formatServiceProvider(serviceProvider) {
        if (serviceProvider.loading) {
            return serviceProvider.name;
        }
        var markup =
            '<div class="select2-search-result">' +
                '<h5 class="select2-search-result-name">' + serviceProvider.name + '</h5>' +
                '<div class="select2-search-result-location">' + serviceProvider.city + ', ' + serviceProvider.region + '</div>' +
            '</div>';

        return markup;
    }
});
